
import Vue from "vue";
import NavBar from "@/components/navigation/NavBar.vue";
import Alert from "@/components/dialogs/Alert.vue";
import Preloader from "@/components/dialogs/Preloader.vue";
import SideBar from "@/components/navigation/SideBar.vue";
import ThemeSettings from "@/components/settings/ThemeSettings.vue";
import Footer from "@/components/navigation/Footer.vue";
import WaitCountdown from "@/modules/auth/views/wait_countdown.vue";
import { timeToStart, timeToEnd } from "@/config/registrationWindow";

export default Vue.extend({
  name: "Default",

  components: { Footer, ThemeSettings, SideBar, Preloader, Alert, NavBar, WaitCountdown },

  data: () => ({
    timeToStart,
    timeToEnd,
  }),

  computed: {
    blocked(): boolean {
      const now = new Date();
      return now < new Date(this.timeToStart) || now > new Date(this.timeToEnd);
    },
    showWaitCountdown(): boolean {
      const hasAccessToken = this.$store.getters["authentication/hasAccessToken"];
      const user = this.$store.getters["user/info"];
      return hasAccessToken && user?.role?.name === "guest" && this.blocked;
    },
    hasEnded(): boolean {
      return new Date() > new Date(this.timeToEnd);
    },
  },
});
